<template>
  <div class="flex-container">
    <!-- 顶部 header -->
    <div class="flex-header" v-loading="loading.channel">
      <div class="channel-header" v-if="channel">
        <h2 class="channel-title">
          {{ channel.channelName }}
          <el-tag
            :type="channel.saleModel === '0' ? 'success' : channel.saleModel === '1' ? 'info' : ''"
            size="small"
            style="margin-left:10px"
          >{{ channel.saleModel === '0' ? '线上' : channel.saleModel === '1' ? '线下' : '-' }}</el-tag>
          <el-tag
              v-if="!channel.exitDate"
              :type="auditStateTagType(channel.auditState)"
              size="small"
              style="margin-left:8px"
          >{{ auditStateText(channel.auditState) }}</el-tag>
          <el-tag
              v-if="channel.exitDate"
              type="error"
              size="small"
              style="margin-left:8px;vertical-align:middle;background:#f56c6c;color:#fff;border-color:#f56c6c;font-weight:bold;"
          >
            已退出
          </el-tag>
        </h2>
        <div class="info-card__meta">
          <div class="meta-item">
            <span class="meta-label">统一信用代码</span>
            <span class="meta-value">{{ channel && channel.creditCode || '-' }}</span>
          </div>
          <div class="meta-divider" />

          <div class="meta-item" v-if="channel.publicityDate">
            <span class="meta-label">公示日期</span>
            <span class="meta-value">{{ channel && channel.publicityDate || '-' }}</span>
          </div>
          <div class="meta-divider" v-if="channel.publicityDate"/>

          <div class="meta-item" v-if="channel.checkDate">
            <span class="meta-label">提测日期</span>
            <span class="meta-value">{{ channel && channel.checkDate || '-' }}</span>
          </div>
          <div class="meta-divider" v-if="channel.checkDate"/>

          <div class="meta-item" v-if="channel.joinDate">
            <span class="meta-label">挂网日期</span>
            <span class="meta-value">{{ channel && channel.joinDate || '-' }}</span>
          </div>
          <div class="meta-divider" v-if="channel.joinDate"/>

          <div class="meta-item" v-if="channel.exitDate">
            <span class="meta-label">退出日期</span>
            <span class="meta-value">{{ channel && channel.exitDate || '-' }}</span>
          </div>
          <div class="meta-divider" v-if="channel.exitDate"/>

          <div class="meta-item">
            <span class="meta-label">创建时间</span>
            <span class="meta-value">{{ channel && channel.createTime || '-' }}</span>
          </div>
          <div class="meta-spacer" />
          <el-button type="primary" size="small" icon="el-icon-back" @click="goBack">返回列表</el-button>
        </div>
      </div>
    </div>

    <!-- 主体内容：Tab 面板 -->
    <div class="flex-item main-content">
      <el-tabs v-model="activeTab" class="detail-tabs" @tab-click="onTabClick">
        <!-- Tab 1：基本信息 -->
        <el-tab-pane label="基本信息" name="basic">
          <el-card class="section-card" shadow="never">
            <div slot="header" class="section-header">
              <span>渠道信息</span>
            </div>
            <div class="descriptions-scroll">
              <el-descriptions :column="2" border size="small" :label-style="labelStyle" :content-style="contentStyle">
                <el-descriptions-item label="渠道名称">{{ channel ? channel.channelName : '-' }}</el-descriptions-item>
                <el-descriptions-item label="企业简称">{{ channel && channel.channelShortName || '-' }}</el-descriptions-item>
                <el-descriptions-item label="统一信用代码">{{ channel ? channel.creditCode : '-' }}</el-descriptions-item>
                <el-descriptions-item label="经营模式">{{ channel && (channel.saleModel === '0' ? '线上' : channel.saleModel === '1' ? '线下' : '-') }}</el-descriptions-item>
                <el-descriptions-item label="注册所在地">{{ channel && channel.regLocation || '-' }}</el-descriptions-item>
                <el-descriptions-item label="总部地址">{{ channel && channel.officeAddress || '-' }}</el-descriptions-item>
                <el-descriptions-item label="企业官网域名">{{ channel && channel.website || '-' }}</el-descriptions-item>
                <el-descriptions-item label="线上平台名称">{{ channel && channel.platformName || '-' }}</el-descriptions-item>
                <el-descriptions-item label="法定代表人">{{ channel && channel.legalRep || '-' }}</el-descriptions-item>
                <el-descriptions-item label="业务联系人">{{ channel && channel.contact || '-' }}</el-descriptions-item>
                <el-descriptions-item label="法人手机号">{{ channel && channel.legalRepPhone || '-' }}</el-descriptions-item>
                <el-descriptions-item label="联系人手机号">{{ channel && channel.contactPhone || '-' }}</el-descriptions-item>
                <el-descriptions-item label="经营范围" :span="2">{{ channel && channel.businessScope || '-' }}</el-descriptions-item>
                <el-descriptions-item label="企业简述" :span="2">{{ channel && channel.summary || '-' }}</el-descriptions-item>
              </el-descriptions>
            </div>
          </el-card>
        </el-tab-pane>

        <!-- Tab 2：渠道文件 -->
        <el-tab-pane label="渠道文件" name="qualification">
          <div class="tree-container" v-loading="loading.files">
            <el-tree
                v-if="qualificationFiles.length > 0"
                :data="qualificationFiles"
                :props="{ children: 'children', label: 'label' }"
                default-expand-all
                node-key="id"
                highlight-current
                style="width: 100%; padding: 8px 0;"
            >
              <span slot-scope="{ node, data }" class="custom-tree-node">
                <span class="tree-node-label" :title="data.label">
                  <i :class="data.type === 'folder' ? 'el-icon-folder' : getFileIcon(data.extension)" class="tree-node-icon"></i>
                  {{ data.label }}
                </span>
                <span class="tree-node-actions" v-if="data.type === 'file'">
                  <el-button type="text" size="mini" @click.stop="previewFile(data)" v-if="data.extension === 'pdf'">预览</el-button>
                  <el-button type="text" size="mini" @click.stop="downloadFile(data)">下载</el-button>
                </span>
              </span>
            </el-tree>
            <el-empty v-else description="暂无资质文件" />
          </div>
        </el-tab-pane>

        <!-- Tab 3：上传文件 -->
        <el-tab-pane label="上传文件" name="upload">
          <div class="file-table-wrapper" v-loading="loading.upload">
            <el-table
              v-if="uploadRecordList.length > 0"
              :data="uploadRecordList"
              border
              size="small"
              style="width:100%;"
            >
              <el-table-column type="index" label="序号" width="60" align="center" />
              <el-table-column prop="wfType" label="申报类型" min-width="200" show-overflow-tooltip />
              <el-table-column prop="fileName" label="文件名称" min-width="200" show-overflow-tooltip />
              <el-table-column prop="uploadDate" label="上传时间" width="170" align="center" />
              <el-table-column label="操作" width="100" align="center" fixed="right">
                <template slot-scope="scope">
                  <el-button type="text" size="small" @click="downloadFile(scope.row)">下载</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-empty v-else description="暂无上传记录" />
            <div class="pagination" style="text-align:right;margin-top:12px;flex-shrink:0;">
              <el-pagination
                @size-change="handleUploadSizeChange"
                @current-change="handleUploadCurrentChange"
                :current-page="uploadPage"
                :page-sizes="[10, 20, 50]"
                :page-size="uploadPageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="uploadTotal"
              />
            </div>
          </div>
        </el-tab-pane>

        <!-- Tab 4：流程列表 -->
<!--        <el-tab-pane label="流程列表" name="workflow">-->
<!--          <el-form :inline="true" size="mini" :model="searchForm" class="search-form">-->
<!--            <el-form-item label="搜索词：">-->
<!--              <el-input v-model="searchForm.keyword" clearable placeholder="请输入商户/门店名称" style="width:160px" @keyup.enter.native="onSearch" />-->
<!--            </el-form-item>-->
<!--            <el-form-item label="流程类型：">-->
<!--              <el-select v-model="searchForm.wfType" placeholder="全部" clearable style="width:140px">-->
<!--                <el-option v-for="item in wfTypeList" :key="item.value" :value="item.value" :label="item.label" />-->
<!--              </el-select>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="审批状态:">-->
<!--              <el-select v-model="searchForm.wfState" placeholder="请选择" clearable style="width:140px">-->
<!--                <el-option v-for="item in wfStateList" :key="item.value" :value="item.value" :label="item.label" />-->
<!--              </el-select>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="创建时间:">-->
<!--              <el-date-picker-->
<!--                  v-model="searchForm.startDate"-->
<!--                  type="date"-->
<!--                  placeholder="开始日期"-->
<!--                  value-format="yyyy-MM-dd"-->
<!--                  style="width:130px"-->
<!--              />-->
<!--              <span style="margin:0 4px;color:#909399">—</span>-->
<!--              <el-date-picker-->
<!--                  v-model="searchForm.endDate"-->
<!--                  type="date"-->
<!--                  placeholder="结束日期"-->
<!--                  value-format="yyyy-MM-dd"-->
<!--                  style="width:130px"-->
<!--              />-->
<!--            </el-form-item>-->
<!--            <el-form-item>-->
<!--              <el-button type="primary" @click="onSearch">查询</el-button>-->
<!--              <el-button @click="onReset">重置</el-button>-->
<!--            </el-form-item>-->
<!--          </el-form>-->
<!--          <el-table-->
<!--            ref="workflowTable"-->
<!--            :data="tableData"-->
<!--            border-->
<!--            size="small"-->
<!--            v-loading="loading.workflow"-->
<!--            :height="tableHeight"-->
<!--            style="width: 100%"-->
<!--          >-->
<!--            <el-table-column type="index" align="center" width="60" label="序号" />-->
<!--            <el-table-column prop="channelName" align="left" min-width="140px" label="渠道名称" show-overflow-tooltip />-->
<!--            <el-table-column prop="wfType" align="center" min-width="100px" label="申报类型">-->
<!--              <template slot-scope="scope">-->
<!--                <span>{{ getWfTypeText(scope.row.wfType) }}</span>-->
<!--              </template>-->
<!--            </el-table-column>-->
<!--            <el-table-column prop="state" align="center" min-width="100px" label="审批状态">-->
<!--              <template slot-scope="scope">-->
<!--                <span>{{ getWfStateText(scope.row.state) }}</span>-->
<!--              </template>-->
<!--            </el-table-column>-->
<!--            <el-table-column prop="createTime" align="center" width="160" label="创建时间" />-->
<!--            <el-table-column label="操作" align="center" width="100" fixed="right">-->
<!--              <template slot-scope="{ row }">-->
<!--                <el-button type="text" size="small" @click="viewWorkflow(row)">查看</el-button>-->
<!--              </template>-->
<!--            </el-table-column>-->
<!--          </el-table>-->
<!--          <div class="pagination">-->
<!--            <el-pagination-->
<!--              @size-change="handleSizeChange"-->
<!--              @current-change="handleCurrentChange"-->
<!--              :current-page="currentPage"-->
<!--              :page-sizes="[10, 20, 50]"-->
<!--              :page-size="pageSize"-->
<!--              layout="total, sizes, prev, pager, next, jumper"-->
<!--              :total="total"-->
<!--            />-->
<!--          </div>-->
<!--        </el-tab-pane>-->
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { detail, getQualificationFiles, getUploadFileList, getWorkflowsByChannel } from '@/api/system/channel'
import * as util from "@/assets/js/util";
import { SYS_APi_SCREENING_URL } from '@/utils/globals';
import { streamDownload } from '@/utils/download';
import axios from "axios";

const wfTypeMap = { '1': '渠道遴选', '2': '新增商户/门店', '4': '修改商户/门店', '3': '退出商户/门店', '6': '支付业务许可证' };
const stateMap = { 'draft': '待提交', 'reviewing': '审核中', 'completed': '审核完成'};
const wfTypeList = [
  { value: '1', label: '渠道遴选' },
  { value: '2', label: '新增商户/门店' },
  { value: '4', label: '修改商户/门店' },
  { value: '3', label: '退出商户/门店' },
  { value: '6', label: '支付业务许可证'}
]

const wfStateList = [
  { value: 'draft', label: '待提交' },
  { value: 'reviewing', label: '审核中' },
  { value: 'completed', label: '审核完成' }
]

const wfStateTagTypeMap = { '0': 'info', '1': 'warning', '3': 'warning', '6': 'success', '4': 'danger', '7': 'danger' }
const auditStateTagTypeMap = { '0': 'info', '1': 'warning', '3': 'warning', '6': 'success', '4': 'danger', '7': 'danger' }

export default {
  name: 'channelView',
  data() {
    return {
      userRole: '',
      channelId: '',
      channelName: '',
      listSearchForm: {},
      activeTab: 'basic',
      channel: null,
      tableData: [],
      tableHeight: 400,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      searchForm: { wfType: '', wfState: '', keyword: '', startDate: '', endDate: '' },
      wfTypeList,
      wfStateList,
      qualificationFiles: [],
      uploadRecordList: [],
      uploadTotal: 0,
      uploadPage: 1,
      uploadPageSize: 10,
      loading: { channel: true, workflow: false, files: false, upload: false },
      labelStyle: {
        width: '130px',
        minWidth: '130px',
        textAlign: 'right',
        whiteSpace: 'nowrap',
        fontWeight: '500',
        color: '#606266',
        backgroundColor: '#fafafa'
      },
      contentStyle: {
        minWidth: '180px',
        wordBreak: 'break-all',
        lineHeight: '1.6',
        color: '#303133'
      }
    }
  },
  created() {
    this.userRole = util.session("userRole") && util.session("userRole").userRole || '';
    this.channelId = this.$route.params.channelId || ''
    const from = this.$route.query.from || ''
    if (from === 'workflowView') {
      this.searchForm = {
        keyword: this.$route.query.keyword || '',
        wfType: this.$route.query.wfType || '',
        wfState: this.$route.query.wfState || '',
        startDate: this.$route.query.startDate || '',
        endDate: this.$route.query.endDate || ''
      }
      this.listSearchForm = {
        channelId: this.$route.query.channelKey || '',
        auditState: this.$route.query.channelAuditState || '',
        currentPage: this.$route.query.currentPage || 1,
        pageSize: this.$route.query.pageSize || 10
      }
      this.activeTab = 'workflow'
    } else {
      this.listSearchForm = {
        channelId: this.$route.query.channelId || '',
        auditState: this.$route.query.auditState || '',
        saleModel: this.$route.query.saleModel || '',
        isPublicityDate: this.$route.query.isPublicityDate || '',
        isCheckDate: this.$route.query.isCheckDate || '',
        isJoinDate: this.$route.query.isJoinDate || '',
        isExitDate: this.$route.query.isExitDate || '',
        timeField: this.$route.query.timeField || '',
        startTime: this.$route.query.startTime || '',
        endTime: this.$route.query.endTime || '',
        currentPage: this.$route.query.currentPage || 1,
        pageSize: this.$route.query.pageSize || 10
      }
    }
    if (!this.channelId) {
      this.$message.error('渠道ID不能为空')
      this.goBack()
      return
    }
    this.loadChannel()
  },
  mounted() {
    window.fileDownTxt = this.fileDownTxt;
    this.setTableHeight();
    window.addEventListener('resize', this.setTableHeight);
    if (this.activeTab === 'workflow' && this.tableData.length === 0) {
      this.fetchWorkflows()
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setTableHeight);
    delete window.fileDownTxt;
  },
  methods: {
    onTabClick(tab) {
      if (tab.paneName === 'qualification' && this.qualificationFiles.length === 0) {
        this.loadQualificationFiles()
      }
      if (tab.paneName === 'upload') {
        this.uploadPage = 1
        this.loadUploadFiles()
      }
      if (tab.paneName === 'workflow' && this.tableData.length === 0) {
        this.fetchWorkflows()
      }
    },
    loadChannel() {
      this.loading.channel = true
      detail({ id: this.channelId })
        .then(res => {
          if (res && res.code === '200' && res.data) {
            this.channel = res.data
            this.channelName = res.data.channelName || ''
          } else {
            this.$message.error(res && res.message ? res.message : '加载渠道信息失败')
          }
        })
        .catch(() => {
          this.$message.error('加载渠道信息失败，请稍后重试')
        })
        .finally(() => {
          this.loading.channel = false
        })
    },
    loadQualificationFiles() {
      this.loading.files = true
      getQualificationFiles({ channelId: this.channelId, userRole: this.userRole })
        .then(res => {
          if (res && res.code === '200') {
            this.qualificationFiles = res.data || []
          } else {
            this.qualificationFiles = []
          }
        })
        .catch(() => {
          this.qualificationFiles = []
        })
        .finally(() => {
          this.loading.files = false
        })
    },
    loadUploadFiles() {
      this.loading.upload = true
      getUploadFileList({ channelId: this.channelId, pageNo: this.uploadPage, pageSize: this.uploadPageSize })
        .then(res => {
          if (res && res.code === '200') {
            this.uploadRecordList = (res.data && res.data.records) || []
            this.uploadTotal = res.data && res.data.total || 0
          } else {
            this.uploadRecordList = []
            this.uploadTotal = 0
          }
        })
        .catch(() => {
          this.uploadRecordList = []
          this.uploadTotal = 0
        })
        .finally(() => {
          this.loading.upload = false
        })
    },
    handleUploadSizeChange(val) {
      this.uploadPageSize = val
      this.uploadPage = 1
      this.loadUploadFiles()
    },
    handleUploadCurrentChange(val) {
      this.uploadPage = val
      this.loadUploadFiles()
    },
    fetchWorkflows() {
      this.loading.workflow = true
      getWorkflowsByChannel({
        channelId: this.channelId,
        keyword: this.searchForm.keyword,
        dataType: this.searchForm.wfType,
        status: this.searchForm.wfState,
        startTime: this.searchForm.startDate,
        endTime: this.searchForm.endDate,
        pageNo: this.currentPage,
        pageSize: this.pageSize
      })
        .then(res => {
          if (res && res.code === '200') {
            this.total = res.data.total || 0
            this.tableData = res.data.records || []
          } else {
            this.$message.error(res && res.message ? res.message : '查询失败')
            this.tableData = []; this.total = 0
          }
        })
        .catch(() => {
          this.$message.error('查询失败，请稍后重试')
          this.tableData = []; this.total = 0
        })
        .finally(() => { this.loading.workflow = false })
    },
    formatAuditDesc(row) {
      let finalDesc = row.auditDesc || '';

      if (!finalDesc) return '';
      return finalDesc
          .split(/\r?\n/)
          .map(line => line.trim())
          .filter(line => line !== '')
          .join('<br>');
    },
    onSearch() { this.currentPage = 1; this.fetchWorkflows() },
    onReset() { this.searchForm = { wfType: '', wfState: '', keyword: '', startDate: '', endDate: '' }; this.onSearch() },
    getWfTypeText(type) { return wfTypeMap[type] || '-'; },
    getWfStateText(state) { return stateMap[state] || '-'; },
    handleSizeChange(val) { this.pageSize = val; this.currentPage = 1; this.fetchWorkflows() },
    handleCurrentChange(val) { this.currentPage = val; this.fetchWorkflows() },
    setTableHeight() {
      this.$nextTick(() => {
        if (typeof window !== 'undefined') {
          const clientHeight = window.innerHeight || document.documentElement.clientHeight
          this.tableHeight = Math.round(clientHeight * 0.58) - 220
        }
      })
    },
    viewWorkflow(row) {
      this.$router.push({
        path: '/sys/adminChannel/workflowView',
        query: {
          channelId: this.channelId,
          channelName: this.channelName,
          flowId: row.parentId,
          keyword: this.searchForm.keyword || '',
          wfType: this.searchForm.wfType || '',
          wfState: this.searchForm.wfState || '',
          startDate: this.searchForm.startDate || '',
          endDate: this.searchForm.endDate || '',
          channelKey: this.listSearchForm.channelId || '',
          channelAuditState: this.listSearchForm.auditState || ''
        }
      })
    },
    goBack() {
      this.$router.push({
        path: '/sys/adminChannel/list',
        query: this.listSearchForm
      })
    },
    getFileIcon(ext) {
      const map = { pdf: 'el-icon-document', xlsx: 'el-icon-tickets', xls: 'el-icon-tickets', doc: 'el-icon-document', docx: 'el-icon-document', zip: 'el-icon-folder-opened', rar: 'el-icon-folder-opened' }
      return map[ext] || 'el-icon-document'
    },
    previewFile(file) {
      if (!file.path) return;
      const loading = this.$loading({
        lock: true,
        text: '加载文件中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      const token = this.$store.state.token;
      if (!token) {
        this.$message.error('未登录，无法预览');
        loading.close();
        return;
      }
      const apiUrl = SYS_APi_SCREENING_URL + '/filedown/bigFileDownLoad';
      const params = new URLSearchParams();
      params.append('url', file.path);
      params.append('name', file.label);
      const finalUrl = `${apiUrl}?${params.toString()}`;
      fetch(finalUrl, { headers: { 'token': token } })
          .then(res => {
            if (!res.ok) throw new Error(`服务器错误: ${res.status}`);
            return res.blob();
          })
          .then(blob => {
            loading.close();
            const blobUrl = window.URL.createObjectURL(new Blob([blob], { type: 'application/pdf' }));
            window.open(blobUrl, '_blank');
          })
          .catch(() => {
            loading.close();
            this.$message.error('预览失败');
          });
    },
    downloadFile(row) {
      const loading = this.$loading({
        lock: true,
        text: '正在下载...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      const apiUrl = SYS_APi_SCREENING_URL + '/filedown/bigFileDownLoad';
      const params = new URLSearchParams();
      params.append('url', row.path || row.filePath || '');
      params.append('name', row.label || row.fileName || 'download');
      const finalUrl = `${apiUrl}?${params.toString()}`;
      const token = this.$store.state.token;
      if (!token) {
        this.$message.error('未登录，无法下载');
        loading.close();
        return;
      }
      streamDownload(finalUrl, {
          token,
          filename: row.label || row.fileName || 'download',
          onProgress: (percent, downloadedMB) => {
            if (!percent) {
              loading.setText('正在下载...');
            } else if (downloadedMB < 1) {
              loading.setText(`正在下载 ${percent}% (${(downloadedMB * 1024).toFixed(0)} KB)...`);
            } else {
              loading.setText(`正在下载 ${percent}% (${downloadedMB.toFixed(1)} MB)...`);
            }
          },
        })
        .then(() => { this.$message.success('下载成功'); })
        .catch(err => {
          if (err.name !== 'AbortError') {
            console.error(err);
            this.$message.error(err.message || '下载失败');
          }
        })
        .finally(() => { loading.close(); });
    },
    async fileDownTxt(channelId){
      try {
        const response = await axios.get(`/couponScreening/file/downloadTxt?channelId=`+channelId, {
          responseType: 'blob',
          headers: {
            'Accept': 'text/plain'
          }
        })
        const contentDisposition = response.headers['content-disposition'];
        let fileName = '审批意见.txt';
        const blob = new Blob([response.data], { type: 'text/plain;charset=utf-8' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('下载失败', error);
      }
    },
    wfStateTagType(state) { return wfStateTagTypeMap[state] || 'info' },
    auditStateTagType(state) { return auditStateTagTypeMap[state] || 'info' },
    auditStateText(state) {
      const map = { '0': '待提交', '1': '审核中', '3': '审核中', '6': '已通过', '4': '初审驳回', '7': '复审驳回' }
      return map[state] || '-'
    }
  }
}
</script>

<style scoped>
.flex-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  text-align: left;
  padding: 0 !important;
  box-sizing: border-box;
}
.flex-header {
  flex-shrink: 0;
  background: #fff;
  padding: 12px 16px;
  border-radius: 8px;
  background-color: #dce4f0;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.06);
}
.flex-item:nth-child(2) {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  margin-top: 12px;
}

.main-content {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* 渠道 header */
.channel-header {
  padding: 0;
}
.channel-title {
  font-size: 20px;
  font-weight: 600;
  color: #303133;
  margin: 0;
  display: flex;
  align-items: center;
}
.channel-meta {
  margin-top: 10px;
  font-size: 13px;
  color: #909399;
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
}
.channel-meta span { white-space: nowrap; }

/* Tab 容器 */
.detail-tabs {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.06);
  padding: 0 16px;
}
.detail-tabs >>> .el-tabs__header {
  background: #fff;
  margin-bottom: 0;
  flex-shrink: 0;
  border-bottom: 1px solid #ebeef5;
}
.detail-tabs >>> .el-tabs__content {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 16px 0;
  padding-right: 6px;
  display: flex;
  flex-direction: column;
}
.detail-tabs >>> .el-tab-pane {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

/* 搜索表单 */
.search-form {
  flex-shrink: 0;
  margin-bottom: 12px;
}

/* 表格 */
.detail-tabs >>> .el-table {
  flex: 1;
  min-height: 0;
}
.pagination {
  text-align: right;
  margin-top: 12px;
  flex-shrink: 0;
}

/* 卡片 */
.section-card {
  border-radius: 6px;
  border: none;
  box-shadow: none;
  background: transparent;
  flex-shrink: 0;
  overflow: auto;
}
.section-card >>> .el-card__header {
  padding: 8px 0;
  background: transparent;
  border-bottom: 1px solid #ebeef5;
}
.section-header {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
  display: flex;
  align-items: center;
}
.section-header::before {
  content: '';
  display: inline-block;
  width: 3px;
  height: 16px;
  background: #409EFF;
  border-radius: 2px;
  margin-right: 8px;
}

/* 描述列表水平滚动 */
.descriptions-scroll {
  width: 100%;
  overflow-x: auto;
  padding-bottom: 4px;
}

/* 文档树容器 */
.tree-container {
  width: 100%;
  height: 100%;
  overflow: auto;
  padding-bottom: 8px;
}

/* 上传文件表格容器 */
.file-table-wrapper {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.file-table-wrapper >>> .el-table {
  flex: 1;
  min-height: 0;
}
.file-table-wrapper >>> .el-table__body-wrapper {
  overflow-y: auto;
  overflow-x: auto;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
  min-width: 0;
}
.tree-node-label {
  display: flex;
  align-items: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
  min-width: 0;
}
.tree-node-icon {
  margin-right: 6px;
  font-size: 16px;
  color: #606266;
}
.tree-node-actions {
  display: flex;
  align-items: center;
  margin-left: 12px;
  flex-shrink: 0;
}
.tree-node-actions .el-button { padding: 0; margin-left: 8px; }

/* 滚动条 */
.detail-tabs >>> .el-tabs__content::-webkit-scrollbar,
.descriptions-scroll::-webkit-scrollbar,
.tree-container::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
.detail-tabs >>> .el-tabs__content::-webkit-scrollbar-track,
.descriptions-scroll::-webkit-scrollbar-track,
.tree-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}
.detail-tabs >>> .el-tabs__content::-webkit-scrollbar-thumb,
.descriptions-scroll::-webkit-scrollbar-thumb,
.tree-container::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}
.detail-tabs >>> .el-tabs__content::-webkit-scrollbar-thumb:hover,
.descriptions-scroll::-webkit-scrollbar-thumb:hover,
.tree-container::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.remark-text {
  color: #909399;
  font-size: 12px;
}

/* 信息行：横向排列所有字段 */
.info-card__meta {
  display: flex;
  align-items: center;
  gap: 0;
  flex-wrap: nowrap;
  overflow: hidden;
}
.meta-item {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
  min-width: 0;
}
.meta-label {
  font-size: 12px;
  color: #909399;
  white-space: nowrap;
  flex-shrink: 0;
}
.meta-value {
  font-size: 13px;
  color: #606266;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
  flex: 1;
}
.meta-divider {
  width: 1px;
  height: 14px;
  background: #1557da;
  flex-shrink: 0;
  margin: 0 12px;
}
.meta-spacer {
  flex: 1;
  min-width: 8px;
}
.cell-ellipsis {
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
}
.tooltip-content {
  max-height: 400px;      /* 超过这个高度就滚动 */
  overflow-y: auto;
  word-break: break-all;  /* 长串不换行时强制换行 */
  line-height: 1.5;
}
</style>
